<template>
    <div class="login-page" :class="{ 'login-page__mobile': $q.screen.lt.md, 'login-page__smallest': $q.screen.lt.sm }">
        <div class="login-page__sign">
            <div class="login-page__sign_form col-grow">
                <img :src="`/assets/${service}/logo-full-light.svg`" alt="logo" width="180" />
                <slot />
            </div>
            <div v-if="!withoutSupport" class="login-page__sign_support">
                <a href="tel:84951183967">8 (495) 118-39-67</a>
                <a href="mailto:help@pusk.app">help@pusk.app</a>
                <span @click="triggerChatSupport">Написать в чат</span>
            </div>
        </div>
        <div class="login-page__present sm-hide xs-hide text-center">
            <slot name="cover">
                <component :is="coverComponent" v-if="coverComponent" />
                <img v-else :src="coverSrc" alt="present-pic" />
            </slot>
            <template v-if="app === 'pusk'">
                <h3 class="text-uppercase">Проектное управление строительной компанией</h3>
                <div class="caption">От планирования до запуска объекта в эксплуатацию</div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

// @ts-ignore
import config from '@platform/shared/config';

export default defineComponent({
    name: 'LoginBase',
    props: {
        withoutSupport: { type: Boolean, default: false },
        coverComponent: { type: Object, required: false },
        width: { type: String, default: '300px' },
        coverUrl: { type: String, required: false },
    },
    setup(props) {
        const triggerChatSupport = () => {
            (window as any).carrotquest?.open();
        };
        const coverSrc = computed(() => {
            if (props.coverUrl) return props.coverUrl;
            return `/assets/${config.serviceVal}/login-present-pic.svg`;
        });
        return { triggerChatSupport, service: config.serviceVal, app: config.app, coverSrc };
    },
});
</script>

<style lang="scss">
.login-page {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: stretch;
    height: 100vh;

    .login-page__sign {
        overflow-y: auto;
        overflow-x: hidden;
        &_form {
            width: v-bind(width);
            display: flex;
            flex-direction: column;
            gap: 12px;
            flex-wrap: nowrap;
            justify-content: center;
            align-items: center;
        }
    }

    &.login-page__smallest .login-page__sign_support {
        flex-direction: column;
        gap: 12px;
    }

    input:not([type='password']) {
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill::first-line {
            -webkit-box-shadow: 0 0 0 1000px #fff inset;
            font-family: 'Roboto', '-apple-system', 'Helvetica Neue', Helvetica, Arial, sans-serif;
            font-weight: normal;
            font-size: 14px;
        }
    }
    input[type='password'] {
        font-family: large Verdana small-caption sans-serif;
        letter-spacing: 1px;
        font-size: 18px !important;
        line-height: 10px;
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill::first-line {
            -webkit-box-shadow: 0 0 0 1000px #fff inset;
            font-family: large Verdana small-caption sans-serif;
            font-weight: normal;
            font-size: 18px;
        }
    }

    a,
    &__sign_support > * {
        color: black;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
            cursor: pointer;
        }
    }

    &.login-page__mobile > &__sign {
        width: 100%;
        box-shadow: none;
    }
    &__sign {
        width: 450px;
        display: flex;
        padding: 0 12px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-shadow: 0px 4px 5px 2px rgba(0, 0, 0, 0.25);

        button[type='submit'],
        button.btn-accented {
            background-color: #0da79b;
        }

        &_support {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 16px 12px;

            > a,
            > span {
                display: block;
            }
        }
    }
    &__present {
        flex-grow: 1;
        width: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow-y: hidden;

        img {
            width: 70%;
        }
        h3 {
            font-size: 1.6vw;
            margin-bottom: 8px;
        }
        .caption {
            font-size: 1.1vw;
        }
    }
}
</style>
